export default __webpack_public_path__ + "static/media/11.ec1a2c9d.png";